import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './reason-dialog.component.html',
    styleUrls: ['./reason-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonDialogComponent {
    newComment;
    constructor(public dialogRef: MatDialogRef<ReasonDialogComponent>) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    closeDialog() {
        if (this.newComment && this.newComment.length > 0) {
            console.log('Submit');
            this.dialogRef.close(this.newComment);
        }
    }
}
